import { HTMLAttributeAnchorTarget } from 'react'
import classNames from 'classnames'

import { Button } from 'client/semantic-imports'

import { IconName, Size, ButtonVariant, ButtonType, Position, AppIcon } from '..'

import styles from './app-button.module.scss'
import classes from '../classes.module.scss'

type AppButtonProps = {
  variant?: ButtonVariant
  text?: string
  size?: Extract<Size, 'small' | 'medium' | 'large'>
  iconName?: IconName
  href?: string
  hrefTarget?: HTMLAttributeAnchorTarget
  position?: Position
  textPosition?: Position
  iconPosition?: 'left' | 'right'
  fullWidth?: boolean
  dataTestId?: string
  ariaLabel?: string
  tabIndex?: number
  // native
  id?: string
  type?: ButtonType
  disabled?: boolean
  loading?: boolean
  onClick?: (e?) => void
}

const AppButton = (props: AppButtonProps) => {
  const {
    variant = 'success',
    text,
    size = 'medium',
    iconName,
    href,
    hrefTarget = '_blank',
    position = 'left',
    textPosition = 'center',
    iconPosition = 'left',
    fullWidth = false,
    dataTestId = 'app-button',
    ariaLabel,
    tabIndex,
    ...rest
  } = props

  const Icon = () => {
    return (
      <span
        data-testid="app-button-icon"
        style={{
          visibility: rest.loading ? 'hidden' : 'visible',
        }}
      >
        <AppIcon name={iconName} size={size} />
      </span>
    )
  }

  const Btn = () => (
    <div className={classes[position]}>
      <Button
        className={classNames(
          styles.appButton,
          styles[variant],
          styles[size],
          styles[`textPosition_${textPosition}`],
          classes[position]
        )}
        fluid={fullWidth}
        data-testid={dataTestId}
        aria-label={ariaLabel}
        tabIndex={tabIndex}
        {...rest}
      >
        <span className={styles.content}>
          {iconName && iconPosition === 'left' && (
            <span className={classNames(text && styles.iconLeft)}>
              <Icon />
            </span>
          )}
          {text && <span className={styles.text}>{text}</span>}
          {iconName && iconPosition === 'right' && (
            <span className={classNames(text && styles.iconRight)}>
              <Icon />
            </span>
          )}
        </span>
      </Button>
    </div>
  )

  if (href) {
    return (
      <a href={href} target={hrefTarget} rel="noreferrer">
        <Btn />
      </a>
    )
  } else {
    return <Btn />
  }
}

export default AppButton
